module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/hikakaku@2x_a0190f734c2d47f800714883f2b2ddcd.png";